var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{class:_vm.variant === 'icon' ? 'with-icon d-flex' : '',attrs:{"show":"","variant":"light","data-qa":"info notice"}},[(_vm.variant === 'icon')?_c('span',{staticClass:"icon-info d-inline-flex"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }